import { defineMessages } from 'react-intl';

export default defineMessages({
  backBtn: {
    id: 'LoginModal.back',
    description: 'Login modal back button',
    defaultMessage: 'Back',
  },
  signIn: {
    id: 'LoginModal.title1',
    description: 'Login modal title 1',
    defaultMessage: 'Sign In',
  },
  almostDone: {
    id: 'LoginModal.title2',
    description: 'Login modal title 2',
    defaultMessage: 'Almost Done!',
  },
  verificationNeededTitle: {
    id: 'LoginModal.verificationNeededTitle',
    description: 'Login modal verification needed box title',
    defaultMessage: 'Verification Needed',
  },
  verifyMessagePt1: {
    id: 'LoginModal.verifyMessagePt1',
    description: 'Login modal verify email message part 1',
    defaultMessage: 'We\'ve sent a verification email to ',
  },
  verifyMessagePt2: {
    id: 'LoginModal.verifyMessagePt2',
    description: 'Login modal verify email message part 2',
    defaultMessage: 'Verification is required before you can sign in. If you didn’t recieve an email, ',
  },
  verifyMessagePt3: {
    id: 'LoginModal.verifyMessagePt3',
    description: 'Login modal verify email message part 3',
    defaultMessage: 'click here',
  },
  verifyMessagePt4: {
    id: 'LoginModal.verifyMessagePt4',
    description: 'Login modal verify email message part 4',
    defaultMessage: 'to resend the verification email.',
  },
  resendVerifyMessagePt1: {
    id: 'LoginModal.resendVerifyMessagePt1',
    description: 'Login modal verification email resent message part 1',
    defaultMessage: 'Verification email resent to',
  },
  resendVerifyMessagePt2: {
    id: 'LoginModal.resendVerifyMessagePt2',
    description: 'Login modal verification email resent message part 1',
    defaultMessage: 'It may take a few minutes.',
  },
  notAuthorized: {
    id: 'LoginModal.notAuthorized',
    description: 'Login modal not authorized exception message',
    defaultMessage: 'The email address and/or password you entered are invalid.',
  },
  verifyPrompt: {
    id: 'LoginModal.verifyPrompt',
    description: 'Login modal email verification prompt',
    defaultMessage: 'Didn\'t receive the verification email?  ',
  },
  resendLink: {
    id: 'LoginModal.resendLink',
    description: 'Login modal resend link text',
    defaultMessage: 'Resend',
  },
  createAccountPrompt: {
    id: 'LoginModal.createAccountPrompt',
    description: 'Login modal create account prompt message',
    defaultMessage: 'Don\'t have an account? ',
  },

  createAccountLink: {
    id: 'LoginModal.createAccountLink',
    description: 'Login modal create account link text',
    defaultMessage: 'Create One',
  },
  resetPasswordSuccess: {
    id: 'LoginModal.resetPasswordSuccess',
    description: 'Reset password success message',
    defaultMessage: 'Reset password successful!',
  },
});
